<template>
    <div class="d-flex flex-wrap flex-xl-nowrap justify-content-center gap-2 gap-lg-5">
        <button
            v-for="type in types"
            :key="type.uid"
            type="button"
            class="button button--lehrplan"
            :class="modelValue == type.uid ? 'button--primary' : 'button--none'"
            @click="onClick(type.uid)"
        >
            {{ type.name }}
        </button>
    </div>
</template>

<script setup>
const props = defineProps({
    modelValue: { type: [Number, String], required: true },
    types: { type: Array, required: true },
});

const emit = defineEmits(['update:modelValue']);

function onClick(uid) {
    if (uid == props.modelValue) return;
    emit('update:modelValue', uid);
}
</script>
